import React from "react";

import TextFieldRenderer from "./fields/TextFieldRenderer";
import ScaleFieldRenderer from "./fields/ScaleFieldRenderer";
import YesNoFieldRenderer from "./fields/YesNoFieldRenderer";
import SingleSelectFieldRenderer from "./fields/SingleSelectFieldRenderer";
import shouldRenderField from "./evaluateConditional";


const RENDERER_BY_TYPE = {
  text: TextFieldRenderer,
  scale: ScaleFieldRenderer,
  yes_no: YesNoFieldRenderer,
  single_select: SingleSelectFieldRenderer,
};


function ConditionalFieldWrapper(props) {
  const field = props.field;
  const visible = shouldRenderField(field, props.responsesByFieldUuid);

  if (!visible) return null;

  const Renderer = RENDERER_BY_TYPE[field.field_type];
  if (!Renderer) {
    return (
      <p className="text-xs italic text-rose-500">
        Unknown field type: {field.field_type}
      </p>
    );
  }

  const currentValue = props.responsesByFieldUuid[field.uuid] ?? null;
  const isFollowUp = !!field.conditional_on_field_uuid;

  return (
    <div className={isFollowUp ? "pl-4 border-l-2 border-violet-100" : ""}>
      <div className="mb-2">
        <p className="text-sm font-medium text-slate-800">
          {field.label}
          {field.is_required && (
            <span className="ml-1 text-rose-500">*</span>
          )}
        </p>
        {field.help_text && (
          <p className="text-xs text-slate-500 whitespace-pre-wrap mt-1">
            {field.help_text}
          </p>
        )}
      </div>
      <Renderer
        field={field}
        value={currentValue}
        onChange={(newValue) => props.onResponseChange(field.uuid, newValue)}
        disabled={props.disabled}
      />
    </div>
  );
}

export default ConditionalFieldWrapper;
